var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8337 1.34167L10.6587 0.166672L6.00033 4.82501L1.34199 0.166672L0.166992 1.34167L4.82533 6.00001L0.166992 10.6583L1.34199 11.8333L6.00033 7.17501L10.6587 11.8333L11.8337 10.6583L7.17533 6.00001L11.8337 1.34167Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCross);
export default __webpack_public_path__ + "static/media/gray_cross.cad3d6c828790b4942e16dc6dc8cd061.svg";
export { ForwardRef as ReactComponent };